import { createStandardAction } from 'typesafe-actions';

export const setCurrentUser = createStandardAction('USER_SET_CURRENT_USER')<
  CurrentUser
>();
export const clearCurrentUser = createStandardAction('USER_CLEAR_CURRENT_USER')<
  void
>();
